import { NavGroup, NavItem } from '@/types/index';

export const adminMenu: NavGroup[] = [
  {
    label: 'Core',
    items: [
      {
        label: 'Dashboard',
        path: '/admin/dashboard'
      },
      {
        label: 'Roles & Permissions',
        path: '/admin/roles-permissions',
        permissions: ['roles.view']
      },
      {
        label: 'Quote Requests',
        path: '/admin/quote-requests',
        permissions: ['roles.view']
      }
    ],
  }
];